import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViewArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M18.18,3.21A10.75,10.75,0,0,1,12,22.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M5.82,20.79A10.75,10.75,0,0,1,12,1.25"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "plan2plate-icon",
			points: "18.84 7.12 17.86 3.21 21.77 3.21"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "plan2plate-icon",
			points: "5.16 16.89 6.14 20.79 2.23 20.79"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M18.84,12A7.52,7.52,0,0,1,12,15.91,7.52,7.52,0,0,1,5.16,12,7.52,7.52,0,0,1,12,8.09,7.52,7.52,0,0,1,18.84,12Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 12,
			cy: 12,
			r: .98
		})
	]
});
const ForwardRef = forwardRef(SvgViewArrow);
export default ForwardRef;
